import { gql } from '@/__generated__/gql';

export const BEGIN_ALLOCATION_TAB_TABLE_DATA_QUERY = gql(`
  query ClientEntityDetailsAllocations($id: String!, $includeRecommendation: Boolean, $sort: String, $order: PaginateSortDirection, $search: String) {
    ClientEntityDetailsAllocations(id: $id, includeRecommendation: $includeRecommendation, sort: $sort, order: $order, search: $search) {
      allocations {
        investmentId
        name
        investmentType
        suitability
        status
        finalClose
        investorDocsDue
        assetClass {
          id
          name
        }
        subAssetClass {
          id
          name
        }
        minimum
        suitabilityCriteria {
          label
          value
        }
        proposalTypeByLegalEntity {
          legalEntityId
          proposalType
          committedCapital
        }
        committedCapital
        legalEntitiesNotEligibleForAllocation
      }
    }
  }
`);

export const BEGIN_ALLOCATION_TAB_GET_INVESTOR_LEGAL_ENTITIES_QUERY = gql(`
  query BeginAllocationTabGetInvestorLegalEntities($data: getInvestorDto!) {
    getInvestor(data: $data) {
      legalEntities {
        id
        entityName
        ignoreBiteSize
        isGroup
        groupId
        entities {
          id
          entityName
          groupId
        }
      }
    }
  }
`);

export const BEGIN_ALLOCATION_TAB_GET_LEGAL_ENTITY_BITE_SIZE_QUERY = gql(`
  query BeginAllocationTabGetLegalEntityBiteSize($id: String!) {
    legalEntity(id: $id) {
      id
      ignoreBiteSize
      defaultBiteSize1
      defaultBiteSize2
    }
  }
`);
